import React, {useEffect, useState} from 'react';
import {InputText} from "primereact/inputtext";
import {InputMask} from "primereact/inputmask";
import {superFormat, superPhoneFormat} from "./Formatters";

const DynamicCell = React.memo(({
                                    node, field,
                                    onEditInputChange, editingRowKey,
                                    isPhone,
                                }) => {

    const [value, setValue] = useState('');

    useEffect(() => {
        if (editingRowKey === node.key && node.data[field])
            setValue(node.data[field]);

    }, [editingRowKey])

    const onLocalChange = (val) => {
        setValue(val);
    }

    const updateRowField = () => {
        onEditInputChange(field, value);
    }

    if (editingRowKey === node.key) {
        if (isPhone) {
            return (
                <div className="p-inputgroup">
                    <InputMask value={value}
                               onBlur={updateRowField}
                               className="w-full md:w-10rem"
                               onChange={(e) => setValue(e.target.value)}
                               mask="999-999-9999" placeholder="999-999-9999"/></div>);
        }

        return (
            <div className="p-inputgroup">
                <InputText
                    type="text"
                    className="w-full md:w-10rem"
                    value={value}
                    onBlur={updateRowField}
                    onChange={(e) => onLocalChange(e.target.value)}
                />
            </div>
        );
    }

    if (field === 'auditSuperName') {
        return superFormat(node.data);
    } else if (field === 'auditSuperPhone') {
        return superPhoneFormat(node.data);
    }

    return node.data[field];
});


export default DynamicCell;

